import { CardBasico } from './CardBasico'
export default CardBasico;

export { skeletonCard } from './card-basico-skeleton';

export {CardBasico, CardBasicoProps} from './CardBasico';
